var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "account",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99999C12.3012 9.99999 14.1667 8.13451 14.1667 5.83332C14.1667 3.53214 12.3012 1.66666 10 1.66666C7.69882 1.66666 5.83334 3.53214 5.83334 5.83332C5.83334 8.13451 7.69882 9.99999 10 9.99999Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6667H14.46C15.0692 11.6668 15.6574 11.8895 16.1141 12.2927C16.5708 12.696 16.8645 13.2521 16.94 13.8567L17.2658 16.46C17.2952 16.6945 17.2742 16.9326 17.2045 17.1584C17.1348 17.3842 17.0178 17.5927 16.8614 17.7698C16.7049 17.947 16.5126 18.0889 16.2971 18.186C16.0817 18.2832 15.848 18.3334 15.6117 18.3333H4.38834C4.15199 18.3334 3.91834 18.2832 3.70288 18.186C3.48742 18.0889 3.29509 17.947 3.13866 17.7698C2.98222 17.5927 2.86525 17.3842 2.79551 17.1584C2.72578 16.9326 2.70487 16.6945 2.73418 16.46L3.05918 13.8567C3.13476 13.2518 3.42869 12.6955 3.8857 12.2922C4.34272 11.8889 4.93132 11.6664 5.54084 11.6667H5.83334",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "ad",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33332 2.91667H11.6667C11.8968 2.91667 12.0833 3.10322 12.0833 3.33334V5.83334C12.0833 6.06346 11.8968 6.25 11.6667 6.25H8.33332C8.1032 6.25 7.91666 6.06346 7.91666 5.83334V3.33334C7.91666 3.10322 8.1032 2.91667 8.33332 2.91667ZM6.66666 3.33334C6.66666 2.41286 7.41285 1.66667 8.33332 1.66667H11.6667C12.5871 1.66667 13.3333 2.41286 13.3333 3.33334V5.83334C13.3333 6.75381 12.5871 7.5 11.6667 7.5H10.625V8.91582C10.815 9.02608 10.9734 9.18478 11.0832 9.375H13.3333C14.599 9.375 15.625 10.401 15.625 11.6667V12.5H16.6667C17.5871 12.5 18.3333 13.2462 18.3333 14.1667V16.6667C18.3333 17.5871 17.5871 18.3333 16.6667 18.3333H13.3333C12.4128 18.3333 11.6667 17.5871 11.6667 16.6667V14.1667C11.6667 13.2462 12.4128 12.5 13.3333 12.5H14.375V11.6667C14.375 11.0914 13.9086 10.625 13.3333 10.625H11.0829C10.8663 11 10.4607 11.2524 9.99623 11.2524C9.53171 11.2524 9.1262 11 8.90957 10.625H6.66666C6.09136 10.625 5.62499 11.0914 5.62499 11.6667V12.5H6.66666C7.58713 12.5 8.33332 13.2462 8.33332 14.1667V16.6667C8.33332 17.5871 7.58713 18.3333 6.66666 18.3333H3.33332C2.41285 18.3333 1.66666 17.5871 1.66666 16.6667V14.1667C1.66666 13.2462 2.41285 12.5 3.33332 12.5H4.37499V11.6667C4.37499 10.401 5.401 9.375 6.66666 9.375H8.9093C9.02053 9.18228 9.18163 9.02191 9.37499 8.91149V7.5H8.33332C7.41285 7.5 6.66666 6.75381 6.66666 5.83334V3.33334ZM6.66666 13.75H3.33332C3.1032 13.75 2.91666 13.9366 2.91666 14.1667V16.6667C2.91666 16.8968 3.1032 17.0833 3.33332 17.0833H6.66666C6.89678 17.0833 7.08332 16.8968 7.08332 16.6667V14.1667C7.08332 13.9366 6.89677 13.75 6.66666 13.75ZM13.3333 13.75H16.6667C16.8968 13.75 17.0833 13.9366 17.0833 14.1667V16.6667C17.0833 16.8968 16.8968 17.0833 16.6667 17.0833H13.3333C13.1032 17.0833 12.9167 16.8968 12.9167 16.6667V14.1667C12.9167 13.9366 13.1032 13.75 13.3333 13.75Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "categories",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.14 6.6262V4.5768C13.14 3.34884 12.1102 2.35338 10.84 2.35338L9.15998 2.35338C7.88973 2.35338 6.85998 3.34884 6.85998 4.5768V6.6262L5.45998 6.6262L5.45998 4.5768C5.45998 2.60139 7.11653 1 9.15998 1H10.84C12.8834 1 14.54 2.60139 14.54 4.5768V6.6262H13.14ZM16 7.9796H4C3.66863 7.9796 3.4 8.23929 3.4 8.55962V16.0999C3.4 16.9541 4.11634 17.6466 5 17.6466H15C15.8837 17.6466 16.6 16.9541 16.6 16.0999V8.55962C16.6 8.23929 16.3314 7.9796 16 7.9796ZM4 6.62622C2.89543 6.62622 2 7.49183 2 8.55962V16.0999C2 17.7016 3.34315 19 5 19H15C16.6569 19 18 17.7016 18 16.0999V8.55962C18 7.49183 17.1046 6.62622 16 6.62622H4ZM11.2904 12.1893C11.2904 12.5975 11.0877 12.9598 10.7743 13.1874L11.2904 14.6844H8.70947L9.22564 13.1874C8.91221 12.9598 8.70947 12.5975 8.70947 12.1893C8.70947 11.5004 9.28724 10.9418 9.99996 10.9418C10.7127 10.9418 11.2904 11.5004 11.2904 12.1893Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#204AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 10.6667L8.66669 12.6667L13.3334 8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.833 10.833 2.5 2.5L14.166 7.5",
    stroke: "#204ab2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-checked",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.4H5A3.6 3.6 0 0 0 1.4 5v10A3.6 3.6 0 0 0 5 18.6h10a3.6 3.6 0 0 0 3.6-3.6V5A3.6 3.6 0 0 0 15 1.4ZM5 0a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5H5Z",
    fill: "#07A9ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.062 6.969a.762.762 0 0 1 .087 1.019l-5.282 6.813-4.365-4.691a.763.763 0 0 1 0-1.024.64.64 0 0 1 .952 0l3.322 3.57 4.338-5.595a.642.642 0 0 1 .948-.092Z",
    fill: "#07A9ED"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "checkbox-frame",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.4H5A3.6 3.6 0 0 0 1.4 5v10A3.6 3.6 0 0 0 5 18.6h10a3.6 3.6 0 0 0 3.6-3.6V5A3.6 3.6 0 0 0 15 1.4ZM5 0a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5H5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close-modal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16.6693L3.33331 3.33594M16.6666 3.33594L3.33331 16.6693",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.567 11.8 4.6 12.834 10.433 7 4.6 1.167 3.567 2.199l4.801 4.8-4.8 4.802Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "collapse-menu",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 6.666V13.3327M9.28139 9.32122L12.8477 6.77388C13.3992 6.37991 14.1654 6.77418 14.1654 7.45199V12.5467C14.1654 13.2245 13.3992 13.6188 12.8477 13.2248L9.28139 10.6774C8.8161 10.3451 8.8161 9.65357 9.28139 9.32122Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "collection-created",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 15.1667L11.6667 18.6667L19.8333 10.5M24.5 14C24.5 19.799 19.799 24.5 14 24.5C8.20101 24.5 3.5 19.799 3.5 14C3.5 8.20101 8.20101 3.5 14 3.5C19.799 3.5 24.5 8.20101 24.5 14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 5.4165V4.58317C8.33398 3.6627 9.08018 2.9165 10.0007 2.9165H15.4173C16.3378 2.9165 17.084 3.6627 17.084 4.58317V9.99984C17.084 10.9203 16.3378 11.6665 15.4173 11.6665H14.584M5.00065 16.6665H10.834C11.7545 16.6665 12.5007 15.9203 12.5007 14.9998V9.1665C12.5007 8.24603 11.7545 7.49984 10.834 7.49984H5.00065C4.08018 7.49984 3.33398 8.24603 3.33398 9.1665V14.9998C3.33398 15.9203 4.08018 16.6665 5.00065 16.6665Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "decline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    stroke: "#E08D8D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70064 15.2986L15.3 8.69922",
    stroke: "#E08D8D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70064 8.70137L15.3 15.3008",
    stroke: "#E08D8D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "dismiss",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 8.66667L12 12M12 12L15.3333 15.3333M12 12L15.3333 8.66667M12 12L8.66667 15.3333M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "drag-n-drop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 5.49967C14.6654 6.00594 14.255 6.41634 13.7487 6.41634C13.2424 6.41634 12.832 6.00594 12.832 5.49967C12.832 4.99341 13.2424 4.58301 13.7487 4.58301C14.255 4.58301 14.6654 4.99341 14.6654 5.49967Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 10.9997C14.6654 11.5059 14.255 11.9163 13.7487 11.9163C13.2424 11.9163 12.832 11.5059 12.832 10.9997C12.832 10.4934 13.2424 10.083 13.7487 10.083C14.255 10.083 14.6654 10.4934 14.6654 10.9997Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 16.4997C14.6654 17.0059 14.255 17.4163 13.7487 17.4163C13.2424 17.4163 12.832 17.0059 12.832 16.4997C12.832 15.9934 13.2424 15.583 13.7487 15.583C14.255 15.583 14.6654 15.9934 14.6654 16.4997Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 5.49967C14.6654 6.00594 14.255 6.41634 13.7487 6.41634C13.2424 6.41634 12.832 6.00594 12.832 5.49967C12.832 4.99341 13.2424 4.58301 13.7487 4.58301C14.255 4.58301 14.6654 4.99341 14.6654 5.49967Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 10.9997C14.6654 11.5059 14.255 11.9163 13.7487 11.9163C13.2424 11.9163 12.832 11.5059 12.832 10.9997C12.832 10.4934 13.2424 10.083 13.7487 10.083C14.255 10.083 14.6654 10.4934 14.6654 10.9997Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 16.4997C14.6654 17.0059 14.255 17.4163 13.7487 17.4163C13.2424 17.4163 12.832 17.0059 12.832 16.4997C12.832 15.9934 13.2424 15.583 13.7487 15.583C14.255 15.583 14.6654 15.9934 14.6654 16.4997Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16536 5.49967C9.16536 6.00594 8.75496 6.41634 8.2487 6.41634C7.74244 6.41634 7.33203 6.00594 7.33203 5.49967C7.33203 4.99341 7.74244 4.58301 8.2487 4.58301C8.75496 4.58301 9.16536 4.99341 9.16536 5.49967Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16536 10.9997C9.16536 11.5059 8.75496 11.9163 8.2487 11.9163C7.74244 11.9163 7.33203 11.5059 7.33203 10.9997C7.33203 10.4934 7.74244 10.083 8.2487 10.083C8.75496 10.083 9.16536 10.4934 9.16536 10.9997Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16536 16.4997C9.16536 17.0059 8.75496 17.4163 8.2487 17.4163C7.74244 17.4163 7.33203 17.0059 7.33203 16.4997C7.33203 15.9934 7.74244 15.583 8.2487 15.583C8.75496 15.583 9.16536 15.9934 9.16536 16.4997Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16536 5.49967C9.16536 6.00594 8.75496 6.41634 8.2487 6.41634C7.74244 6.41634 7.33203 6.00594 7.33203 5.49967C7.33203 4.99341 7.74244 4.58301 8.2487 4.58301C8.75496 4.58301 9.16536 4.99341 9.16536 5.49967Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16536 10.9997C9.16536 11.5059 8.75496 11.9163 8.2487 11.9163C7.74244 11.9163 7.33203 11.5059 7.33203 10.9997C7.33203 10.4934 7.74244 10.083 8.2487 10.083C8.75496 10.083 9.16536 10.4934 9.16536 10.9997Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16536 16.4997C9.16536 17.0059 8.75496 17.4163 8.2487 17.4163C7.74244 17.4163 7.33203 17.0059 7.33203 16.4997C7.33203 15.9934 7.74244 15.583 8.2487 15.583C8.75496 15.583 9.16536 15.9934 9.16536 16.4997Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5502 5.62129L16.9644 4.20708C17.3549 3.81655 17.9881 3.81655 18.3786 4.20708L19.7928 5.62129C20.1834 6.01181 20.1834 6.64498 19.7928 7.0355L18.3786 8.44972L8.96373 17.8647C8.68452 18.1439 8.32892 18.3342 7.94174 18.4117L5 19L5.58835 16.0583C5.66579 15.6711 5.85609 15.3155 6.13529 15.0363L15.5502 5.62129ZM18.3786 8.44972L15.5502 5.62129",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "expand",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.199 3.567 1.166 4.599 7 10.433l5.833-5.834L11.8 3.567 7 8.367l-4.801-4.8Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gear",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.667 2.724c0-.584-.474-1.057-1.058-1.057H9.392c-.585 0-1.059.473-1.059 1.057 0 .482-.33.895-.779 1.072-.07.028-.141.058-.21.088-.443.192-.969.134-1.31-.207a1.057 1.057 0 0 0-1.496 0l-.861.861a1.058 1.058 0 0 0 0 1.495c.341.342.4.867.206 1.31-.03.07-.06.14-.087.211-.177.45-.59.78-1.072.78-.584 0-1.057.473-1.057 1.057v1.218c0 .584.473 1.058 1.057 1.058.482 0 .895.33 1.072.779l.087.21c.193.443.135.97-.206 1.31a1.058 1.058 0 0 0 0 1.496l.861.861a1.057 1.057 0 0 0 1.495 0c.342-.341.867-.4 1.31-.207.07.03.14.06.211.088.45.177.78.59.78 1.072 0 .584.473 1.057 1.057 1.057h1.218c.584 0 1.058-.473 1.058-1.057 0-.482.33-.895.779-1.073.07-.027.142-.056.21-.086.443-.194.97-.134 1.31.206a1.057 1.057 0 0 0 1.496 0l.861-.861a1.057 1.057 0 0 0 0-1.495c-.341-.342-.4-.867-.207-1.31.03-.07.06-.14.088-.211.177-.45.59-.78 1.072-.78.584 0 1.057-.473 1.057-1.057V9.392c0-.584-.473-1.058-1.057-1.058-.482 0-.895-.33-1.073-.779a6.415 6.415 0 0 0-.087-.21c-.192-.443-.133-.97.207-1.31a1.057 1.057 0 0 0 0-1.496l-.861-.861a1.057 1.057 0 0 0-1.495 0c-.342.341-.867.4-1.31.207-.07-.03-.14-.06-.211-.088-.45-.178-.78-.591-.78-1.072Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "go-back",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.916 15.834 7.79 10.707a1 1 0 0 1 0-1.414l5.126-5.126",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "group",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 19v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1m0-8a3 3 0 1 0 0-6m6 14v-1a4 4 0 0 0-4-4h-.5M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "halfcheck",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 10h8.333",
    stroke: "#204ab2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "help",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 15.8333C14.8092 15.8333 16.3808 15.8333 17.3567 14.8567C18.3333 13.8808 18.3333 12.3092 18.3333 9.16667C18.3333 6.02417 18.3333 4.4525 17.3567 3.47667C16.3808 2.5 14.8092 2.5 11.6667 2.5H8.33332C5.19082 2.5 3.61916 2.5 2.64332 3.47667C1.66666 4.4525 1.66666 6.02417 1.66666 9.16667C1.66666 12.3092 1.66666 13.8808 2.64332 14.8567C3.18749 15.4017 3.91666 15.6425 4.99999 15.7483",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 7.07001C8.75001 6.24501 9.16668 5.83334 10 5.83334C11.0383 5.83334 11.6667 6.65751 11.6667 7.48168C11.6667 8.30584 11.25 8.34251 10 9.16668V10M10 12.0833V12.5",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 15.8333C10.6367 15.8333 9.50165 16.25 8.46582 16.7875C6.80082 17.6517 5.96832 18.0842 5.55832 17.8083C5.14832 17.5333 5.22582 16.6792 5.38165 14.9717L5.41665 14.5833",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.3645 0 0 3.38465 0 7.54487C0 11.7051 3.3645 15.0896 7.5 15.0896C11.6355 15.0896 15 11.7051 15 7.54487C15 3.38465 11.6355 0 7.5 0ZM7.5 13.7179C4.11636 13.7179 1.36364 10.9487 1.36364 7.54487C1.36364 4.14106 4.11636 1.37179 7.5 1.37179C10.8836 1.37179 13.6364 4.14106 13.6364 7.54487C13.6364 10.9487 10.8836 13.7179 7.5 13.7179Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50071 3.20081C6.99952 3.20081 6.5918 3.61124 6.5918 4.11574C6.5918 4.61978 6.99952 5.02985 7.50071 5.02985C8.00189 5.02985 8.40962 4.61978 8.40962 4.11574C8.40962 3.61124 8.00189 3.20081 7.50071 3.20081Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50018 6.40173C7.12363 6.40173 6.81836 6.70883 6.81836 7.08763V11.203C6.81836 11.5818 7.12363 11.8889 7.50018 11.8889C7.87672 11.8889 8.182 11.5818 8.182 11.203V7.08763C8.182 6.70883 7.87672 6.40173 7.50018 6.40173Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "linux",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5713 12.8462C13.0916 12.6534 12.8854 12.3993 12.9049 12.018C12.9245 11.5732 12.6662 11.2491 12.5446 11.1199C12.6184 10.8446 12.8355 9.88933 12.5446 9.05904C12.232 8.17156 11.2791 6.81387 10.298 5.4816C9.89642 4.93513 9.87688 4.33995 9.85518 3.64946C9.83347 2.99285 9.80959 2.24729 9.43407 1.41912C9.02599 0.516812 8.20548 0 7.18527 0C6.57749 0 5.95451 0.184273 5.4748 0.50834C4.49366 1.16918 4.62173 2.6116 4.70856 3.56685C4.71941 3.69817 4.73243 3.82102 4.73678 3.92693C4.79321 4.861 4.74112 5.35451 4.67383 5.50278C4.63041 5.60021 4.41335 5.8798 4.18326 6.17421C3.94666 6.47922 3.6775 6.82446 3.45609 7.14641C3.19344 7.53402 2.98072 8.12708 2.7745 8.69897C2.62473 9.11835 2.48147 9.51443 2.34472 9.74954C2.08207 10.2049 2.14719 10.6285 2.20145 10.8255C2.1016 10.8933 1.95834 11.0246 1.83895 11.2746C1.69352 11.5796 1.39614 11.7427 0.779674 11.857C0.495319 11.9142 0.30213 12.0307 0.197939 12.2023C0.0503346 12.4543 0.130649 12.7699 0.204451 12.986C0.312984 13.3037 0.245693 13.5049 0.121966 13.8692C0.0937477 13.9539 0.0611879 14.0492 0.0286281 14.153C-0.0234676 14.3182 -0.0039317 14.4686 0.0828944 14.6021C0.315154 14.9494 0.994569 15.0723 1.69352 15.1528C2.11028 15.2015 2.56829 15.3646 3.01111 15.5213C3.44524 15.6759 3.89239 15.8348 4.2983 15.8835C4.36125 15.892 4.42203 15.8941 4.48064 15.8941C5.09493 15.8941 5.37278 15.4959 5.46177 15.3328C5.68318 15.2883 6.44291 15.1485 7.22869 15.1295C8.01229 15.1083 8.76985 15.2587 8.98475 15.3053C9.05204 15.4324 9.23003 15.7204 9.51438 15.8687C9.67067 15.9513 9.88774 16 10.1091 16C10.3457 16 10.7972 15.9449 11.1554 15.5785C11.5114 15.21 12.4035 14.7397 13.0525 14.3966C13.198 14.3204 13.3326 14.2483 13.452 14.1827C13.8166 13.9857 14.0163 13.7019 13.999 13.4075C13.9903 13.1618 13.8253 12.9478 13.5713 12.8462ZM5.48348 12.7763C5.4379 12.4628 5.02547 12.1536 4.54793 11.7956C4.15721 11.5012 3.7144 11.1687 3.59284 10.8869C3.34105 10.3066 3.53857 9.28356 3.88588 8.75827C4.05736 8.49563 4.19628 8.09531 4.33086 7.7077C4.4763 7.29044 4.62824 6.85835 4.79538 6.66984C5.06237 6.37543 5.30983 5.80143 5.35324 5.34816C5.60287 5.58115 5.99141 5.87768 6.34957 5.87768C6.40384 5.87768 6.4581 5.87133 6.5102 5.8565C6.75548 5.7866 7.11581 5.58327 7.46529 5.38629C7.76701 5.21684 8.13819 5.00715 8.27711 4.98809C8.51588 5.32274 9.90727 8.32619 10.0505 9.29203C10.1634 10.0545 10.044 10.6857 9.98542 10.9335C9.93766 10.9272 9.87906 10.923 9.82045 10.923C9.43407 10.923 9.32988 11.1284 9.30383 11.2534C9.23437 11.5732 9.22786 12.5962 9.22786 12.8271C9.08677 13.0008 8.37913 13.8184 7.36327 13.9666C6.94867 14.0259 6.5623 14.0556 6.21282 14.0556C5.91544 14.0556 5.72442 14.0323 5.64628 14.0217L5.13618 13.4519C5.33588 13.3503 5.53775 13.1448 5.48348 12.7763ZM6.13251 3.36775C6.11731 3.37411 6.09995 3.38258 6.08475 3.38893C6.08258 3.35504 6.08041 3.32115 6.0739 3.28727C6.01746 2.97379 5.80474 2.74715 5.56814 2.74715C5.55077 2.74715 5.53341 2.74927 5.51387 2.75139C5.37278 2.77469 5.26207 2.87848 5.2013 3.02462C5.25556 2.70267 5.44224 2.46333 5.66364 2.46333C5.92412 2.46333 6.14553 2.80646 6.14553 3.21101C6.14336 3.26185 6.14119 3.31268 6.13251 3.36775ZM8.15773 3.60921C8.1816 3.53508 8.19463 3.45459 8.19463 3.37199C8.19463 3.00344 7.95586 2.71538 7.64979 2.71538C7.35241 2.71538 7.1093 3.0098 7.1093 3.37199C7.1093 3.39741 7.11147 3.4207 7.11364 3.44612C7.09845 3.43977 7.08325 3.43341 7.06806 3.42918C7.03333 3.32751 7.01596 3.2216 7.01596 3.11358C7.01596 2.67302 7.30466 2.31506 7.65847 2.31506C8.01229 2.31506 8.30099 2.67302 8.30099 3.11358C8.29882 3.29574 8.24672 3.46942 8.15773 3.60921ZM7.89725 4.46492C7.89291 4.4861 7.88205 4.49669 7.7605 4.55812C7.69972 4.58989 7.62374 4.62801 7.53041 4.68308L7.46746 4.72121C7.21349 4.87159 6.6209 5.22319 6.4581 5.24226C6.34957 5.25708 6.28011 5.21472 6.12816 5.11517C6.09343 5.09187 6.05653 5.06857 6.01746 5.04316C5.74396 4.86735 5.56596 4.67461 5.54643 4.59836C5.63543 4.53058 5.85683 4.36113 5.97188 4.26158C6.20197 4.05189 6.43423 3.9121 6.54927 3.9121C6.55578 3.9121 6.56012 3.9121 6.56664 3.91422C6.70122 3.93752 7.03333 4.06672 7.27644 4.16203C7.38931 4.20651 7.48482 4.24252 7.55428 4.26794C7.77135 4.33783 7.88422 4.43103 7.89725 4.46492ZM9.82913 14.2399C9.95069 13.7061 10.0896 12.9796 10.0679 12.5518C10.0636 12.4543 10.0549 12.3484 10.0462 12.2468C10.031 12.0561 10.0071 11.7702 10.031 11.6855C10.0353 11.6833 10.0419 11.6812 10.0462 11.6791C10.0462 11.9248 10.1026 12.412 10.502 12.5835C10.6214 12.6344 10.7582 12.6598 10.9079 12.6598C11.3095 12.6598 11.7545 12.467 11.9368 12.2891C12.0432 12.1853 12.1344 12.0561 12.1973 11.9545C12.2103 11.9947 12.219 12.0455 12.2147 12.1112C12.1908 12.4713 12.371 12.9521 12.7139 13.1279L12.7639 13.1533C12.8854 13.2147 13.2088 13.382 13.2153 13.4604C13.2153 13.4604 13.2132 13.4689 13.1936 13.4858C13.1133 13.5579 12.8268 13.6998 12.5511 13.8374C12.0606 14.081 11.507 14.3585 11.2574 14.6148C10.9058 14.9748 10.5085 15.2163 10.2698 15.2163C10.2416 15.2163 10.2155 15.2121 10.1916 15.2057C9.92898 15.1295 9.71408 14.763 9.82913 14.2399ZM0.953326 12.8779C0.927279 12.7572 0.905572 12.6619 0.927279 12.5687C0.944644 12.5009 1.29195 12.4268 1.43955 12.395C1.64794 12.3505 1.865 12.3061 2.00609 12.2213C2.19711 12.1091 2.3013 11.8994 2.39247 11.7172C2.45759 11.5838 2.52705 11.4482 2.60736 11.4016C2.61171 11.3995 2.61822 11.3953 2.63124 11.3953C2.78319 11.3953 3.10227 11.7066 3.28678 11.9862C3.33236 12.0561 3.41919 12.198 3.51904 12.3611C3.81859 12.8483 4.22667 13.5176 4.4394 13.74C4.63258 13.9412 4.94299 14.3288 4.86701 14.6593C4.81058 14.9177 4.5132 15.1252 4.44157 15.1718C4.41552 15.1782 4.38513 15.1803 4.34606 15.1803C3.93797 15.1803 3.12832 14.8478 2.69202 14.6698L2.6269 14.6444C2.38379 14.5449 1.98873 14.4835 1.60452 14.422C1.29846 14.3733 0.881695 14.3077 0.812234 14.2483C0.755797 14.1869 0.820917 13.9878 0.879524 13.812C0.920767 13.6849 0.96418 13.5536 0.985886 13.4181C1.02496 13.1999 0.985886 13.0199 0.953326 12.8779Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "lists",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H17.5M2.5 10H17.5M2.5 15H17.5",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "loader",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 30",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#07A9ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.873 7.002v2.042C8.94 6.57 12.02 5 15.459 5c4.1 0 7.687 2.23 9.66 5.564a.708.708 0 0 1-.232.96.679.679 0 0 1-.942-.237C22.209 8.357 19.058 6.4 15.459 6.4 12.28 6.4 9.45 7.926 7.638 10.3h2.47c.379 0 .686.313.686.7 0 .386-.307.7-.686.7H5.5V7.002c0-.386.307-.7.686-.7.38 0 .687.314.687.7Zm.1 11.71a.679.679 0 0 0-.942-.236.708.708 0 0 0-.233.96C7.771 22.77 11.359 25 15.458 25c3.486 0 6.601-1.612 8.67-4.143v2.14c0 .387.307.7.686.7a.693.693 0 0 0 .686-.7v-4.699H20.892a.693.693 0 0 0-.686.7c0 .387.307.7.686.7h2.388c-1.813 2.376-4.642 3.902-7.821 3.902-3.6 0-6.75-1.957-8.486-4.887Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.167 1.667h9.166a2.5 2.5 0 0 1 2.5 2.5v11.666a.833.833 0 0 1-.833.833h-2.5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.167 1.667 6.323 1.265a2.5 2.5 0 0 1 2.01 2.45v11.935a.832.832 0 0 1-.997.816l-5.997-1.198a1.666 1.666 0 0 1-1.34-1.635V1.667ZM10 10v1.667",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "main-menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88867 10.2637H8.22266C8.3682 10.2634 8.48633 10.1456 8.48633 10V2.88867C8.48621 2.74317 8.36813 2.62523 8.22266 2.625H2.88867C2.7431 2.62512 2.62512 2.7431 2.625 2.88867V10C2.625 10.1457 2.74303 10.2636 2.88867 10.2637ZM11.7773 6.70801H17.1113C17.257 6.70789 17.375 6.59001 17.375 6.44434V2.88867C17.3749 2.7431 17.2569 2.62512 17.1113 2.625H11.7773C11.6319 2.62523 11.5138 2.74317 11.5137 2.88867V6.44434C11.5137 6.58993 11.6318 6.70777 11.7773 6.70801ZM11.7773 17.375H17.1113C17.2569 17.3749 17.3749 17.2569 17.375 17.1113V10C17.375 9.85433 17.257 9.73645 17.1113 9.73633H11.7773C11.6318 9.73656 11.5137 9.8544 11.5137 10V17.1113C11.5138 17.2568 11.6319 17.3748 11.7773 17.375ZM2.88867 17.375H8.22266C8.36813 17.3748 8.48621 17.2568 8.48633 17.1113V13.5557C8.48633 13.4101 8.3682 13.2922 8.22266 13.292H2.88867C2.74303 13.2921 2.625 13.41 2.625 13.5557V17.1113C2.62512 17.2569 2.7431 17.3749 2.88867 17.375Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mini-shield",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9975 3C14.3333 5.06658 17.382 6.14257 20.4975 6C20.9511 7.54302 21.0899 9.16147 20.9056 10.7592C20.7214 12.3569 20.2178 13.9013 19.4249 15.3005C18.632 16.6998 17.5659 17.9254 16.29 18.9045C15.014 19.8836 13.5543 20.5962 11.9975 21C10.4407 20.5962 8.981 19.8836 7.70506 18.9045C6.42913 17.9254 5.36302 16.6998 4.57011 15.3005C3.7772 13.9013 3.27365 12.3569 3.08939 10.7592C2.90513 9.16147 3.04392 7.54302 3.49752 6C6.61304 6.14257 9.66168 5.06658 11.9975 3Z",
    fill: "#469DF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11 14L15 10",
    stroke: "#F0F6FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "remove",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 11V17M14 11V17M4 7H20M6 7V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V7H6ZM15 7V5C15 3.89543 14.1046 3 13 3H11C9.89543 3 9 3.89543 9 5V7H15Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "save-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    stroke: "currentColor",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82238 11.9264L10.9741 15.0781L17.2776 8.77465",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "save",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    stroke: "#07A9ED",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82238 11.9264L10.9741 15.0781L17.2776 8.77465",
    stroke: "#07A9ED",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "select-chevron",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L5 9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.16666H5.83333M17.5 4.16666H9.16667M2.5 10H12.5M17.5 10H15.8333M2.5 15.8333H4.16667M17.5 15.8333H7.5",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 5.83333C8.42048 5.83333 9.16668 5.08714 9.16668 4.16667C9.16668 3.24619 8.42048 2.5 7.50001 2.5C6.57954 2.5 5.83334 3.24619 5.83334 4.16667C5.83334 5.08714 6.57954 5.83333 7.50001 5.83333Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6667C15.0871 11.6667 15.8333 10.9205 15.8333 10C15.8333 9.07953 15.0871 8.33334 14.1667 8.33334C13.2462 8.33334 12.5 9.07953 12.5 10C12.5 10.9205 13.2462 11.6667 14.1667 11.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83332 17.5C6.7538 17.5 7.49999 16.7538 7.49999 15.8333C7.49999 14.9129 6.7538 14.1667 5.83332 14.1667C4.91285 14.1667 4.16666 14.9129 4.16666 15.8333C4.16666 16.7538 4.91285 17.5 5.83332 17.5Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "skydns-logo-bg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 65,
    viewBox: "0 0 50 65",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3895 54.9038L16.0281 58.7631L23.459 63.872C24.0978 64.3113 24.942 64.3084 25.5779 63.865L32.8938 58.7631L38.6225 54.8787C40.1111 53.9515 42.6924 52.1973 44.0381 51.0304C45.6079 49.4607 46.8343 47.5966 47.7173 45.4382C48.6003 43.2797 49.0417 40.9349 49.0417 38.4037L49.0417 31.322L45.2986 31.322L41.3892 31.322L41.3892 38.4037C41.3892 39.8949 41.1439 41.2489 40.6534 42.4654C40.1824 43.7016 39.5055 44.7612 38.6225 45.6442C37.7591 46.5272 36.9535 47.0599 35.6755 47.9621L32.3424 50.2175L25.5755 54.8573C24.9402 55.2929 24.1022 55.2921 23.4677 54.8554L16.5669 50.1047C15.2513 49.2025 13.3467 47.937 13.3467 47.937C12.1187 47.1225 11.2729 46.5272 10.3899 45.6442C9.52651 44.7612 8.84956 43.7016 8.35901 42.4654C7.88808 41.2489 7.65261 39.8949 7.65261 38.4037L4.16521e-05 38.4037C4.15415e-05 40.9349 0.441535 43.2797 1.32452 45.4382C2.20752 47.5966 3.42408 49.4607 4.97422 51.0304C6.54397 52.6002 8.40977 53.5756 10.3895 54.9038Z",
    fill: "#204AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000398399 10.7431C0.000398284 9.42838 0.167188 8.25105 0.500762 7.21108C0.834335 6.1515 1.27583 5.22926 1.82525 4.44438C2.37466 3.63988 3.01237 2.96292 3.73839 2.4135C4.4644 1.84447 5.22966 1.38335 6.03416 1.03016C6.81904 0.676958 7.61374 0.421876 8.41824 0.264898C9.22274 0.0883001 9.98799 1.27026e-06 10.714 1.20679e-06L24.5181 0L24.5181 7.65258L10.714 7.65258C9.69366 7.65258 8.92841 7.91747 8.41824 8.44727C7.90807 8.97706 7.65297 9.74233 7.65297 10.7431L7.65297 35.2746L0.000400543 35.2746L0.000398399 10.7431Z",
    fill: "#204AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6561 10.7424L38.3219 10.7424C39.4207 10.7424 40.5981 10.9288 41.8539 11.3017C43.09 11.6745 44.2478 12.2828 45.327 13.1265C46.4062 13.9899 47.299 15.0985 48.0054 16.4524C48.7117 17.826 49.0649 19.5037 49.0649 21.4855L49.0649 28.2075L41.4124 28.2075L41.4124 21.4855C41.4124 20.4848 41.1475 19.7195 40.6177 19.1897C40.0879 18.6599 39.303 18.395 38.263 18.395L27.6561 18.395L27.6561 10.7424Z",
    fill: "#204AB2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sort",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.5V12H6.58333V13.5H2.25ZM2.25 9.75V8.25H10.9167V9.75H2.25ZM2.25 6V4.5H15.25V6H2.25Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "stat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 11.6667L9.16668 8.33334L12.5 11.6667L17.5 6.66667",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66667H17.5V9.16667",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trash-can",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.666 12.8333V19.8333M16.3327 12.8333V19.8333M4.66602 8.16667H23.3327M6.99935 8.16667V21C6.99935 22.933 8.56635 24.5 10.4993 24.5H17.4993C19.4323 24.5 20.9993 22.933 20.9993 21V8.16667H6.99935ZM17.4993 8.16667V5.83333C17.4993 4.54467 16.4547 3.5 15.166 3.5H12.8327C11.544 3.5 10.4993 4.54467 10.4993 5.83333V8.16667H17.4993Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "windows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3296 1.28383C10.2155 0.833373 13.1067 0.409434 15.9983 0C16.0003 2.58466 15.9983 4.84987 16.0003 7.43452C13.1108 7.44571 10.2212 7.49047 7.33001 7.5C7.32757 5.32105 7.32757 3.46113 7.3296 1.28383Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.3299C2.17327 1.98802 4.35547 1.69254 6.53768 1.41406C6.53971 3.55779 6.53971 5.35822 6.54133 7.50195C4.36075 7.49988 2.18058 7.53386 0 7.52806V2.3299Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.18072C2.17855 8.17326 4.3571 8.2089 6.53565 8.20517C6.53565 10.3543 6.54133 12.5034 6.53768 14.6529C4.36075 14.3235 2.18058 14.0359 0 13.735V8.18072Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31641 8.26562C10.2112 8.26562 13.1045 8.26562 15.9977 8.26562C16.0013 10.8428 15.9977 13.42 15.9977 15.9989C13.1118 15.558 10.2206 15.1485 7.329 14.7486C7.32575 12.5883 7.32006 10.428 7.31641 8.26562Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.ff6ff597aa0ecd0b90f72e4e53ba7b54.svg";
export { ForwardRef as ReactComponent };